var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseRadiolist',_vm._b({attrs:{"options":_vm.BDX_CURRENCY_TYPES,"label":"Currency","searchable":false},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'BaseRadiolist',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }